/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LearnMoreLink } from '../../helpers/linkHelpers';
import { ServiceDeskLogo } from '../../helpers/serviceDeskHelpers';
import { useWebChatFeatures } from '../../hooks/useChannelFeatures';
import {
  EGAIN_BYOSD_TYPE,
  ENGHOUSE_BYOSD_TYPE,
  ORACLE_BYOSD_TYPE,
  WEBCHAT_CHANNEL_TYPE,
  WEB_BYOSD_TYPE,
  KUSTOMER_BYOSD_TYPE,
  TWILIO_BYOSD_TYPE
} from '../../util/channelTypes';
import { TabContent } from '../common/tabbed-header/TabContent';
import { WebChatIcon } from '../icons/WebChatIcon';
import { links } from './links';
import { WebChatNew as messages } from './messages';

export const WebChatSplashPage = () => {
  const supportedChannels = useWebChatFeatures();

  const NON_WEB_CHAT_SERVICE_DESKS = [
    EGAIN_BYOSD_TYPE,
    ENGHOUSE_BYOSD_TYPE,
    KUSTOMER_BYOSD_TYPE,
    ORACLE_BYOSD_TYPE,
    TWILIO_BYOSD_TYPE,
    WEB_BYOSD_TYPE
  ];

  // Need to wrap the Image so it will be in color and work with TabContent
  const WrappedImageComponent = () => {
    return (
      <div className="WebChat__icon--brand">
        <WebChatIcon />
      </div>
    );
  };

  return (
    <TabContent
      title={
        <div>
          <FormattedMessage {...messages.title} />
        </div>
      }
      ImageComponent={WrappedImageComponent}>
      <div className="TabContent__body-content">
        <div className="TabContent__subtitle">
          <p>
            <FormattedMessage {...messages.embedDescription} />
            <LearnMoreLink
              className="TabContent__learn-more-link"
              url={links.learnMoreDeployLink}
            />
          </p>
        </div>
        <div className="TabContent__subtitle">
          <p>
            <FormattedMessage {...messages.customizationDescription} />
            <LearnMoreLink
              className="TabContent__learn-more-link"
              url={links.DEVELOPER_LINK}
            />
          </p>
        </div>
        <div className="TabContent__subtitle">
          <p>
            <FormattedMessage {...messages.transferDescription} />
          </p>
        </div>
        {supportedChannels.length > 0 && (
          <div>
            <h4 className="ServiceDesk__supported-services-title">
              <FormattedMessage {...messages.supportedServiceDesksLabel} />
            </h4>
            <div className="ServiceDesk__supported-services">
              {supportedChannels.map(
                serviceDesk =>
                  !NON_WEB_CHAT_SERVICE_DESKS.includes(serviceDesk) && (
                    <ServiceDeskLogo
                      key={`HAA-service--${serviceDesk}`}
                      parentChannelType={WEBCHAT_CHANNEL_TYPE}
                      className="ServiceDesk__supported-service"
                      serviceDeskType={serviceDesk}
                      showTitle={false}
                    />
                  )
              )}
            </div>
          </div>
        )}
      </div>
    </TabContent>
  );
};
